import { Routes } from '@angular/router';
import { presentationResolver } from './page/presentation/resolver/presentation.resolver';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./page/start/start').then((m) => m.Start),
  },
  {
    path: ':id',
    loadComponent: () => import('./page/chat/chat').then((m) => m.Chat),
  },
  {
    path: ':id/summary',
    loadComponent: () => import('./page/summary/summary').then((m) => m.Summary),
  },
  {
    path: ':sessionId/presentation/:presentationId',
    resolve: [presentationResolver],
    loadComponent: () => import('./page/presentation/presentation').then((m) => m.Presentation),
  },
];
